import React from 'react';

function Footer() {
  return (
    <footer className="footer-main">
      <div className="max-w-7xl mx-auto px-6 grid-cols-1-md-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '2rem', fontSize: '0.875rem' }}>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <div style={{ fontSize: '1.125rem', fontWeight: '700', color: 'var(--brand-gold)' }}>
            SAMUDRA
          </div>
          <p>
            Expertise, precision, and reliability in marine claims and
            consultancy. Registered in Singapore.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <h4 style={{ fontWeight: '600', fontSize: '1rem' }}>Quick Links</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
            <li><a href="#services" className="footer-link">Our Services</a></li>
            <li><a href="#claims-center" className="footer-link">Claims Center</a></li>
            <li><a href="#resources" className="footer-link">Case Studies & Insights</a></li>
          </ul>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <h4 style={{ fontWeight: '600', fontSize: '1rem' }}>Compliance & Legal</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
            <li><a href="#" className="footer-link">Privacy Policy (PDPA)</a></li>
            <li><a href="#" className="footer-link">Terms of Service</a></li>
            <li><a href="#" className="footer-link">Sitemap</a></li>
          </ul>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <h4 style={{ fontWeight: '600', fontSize: '1rem' }}>Contact</h4>
          <p>10 Ubi Crescent, #05-42, Ubi Tech Park <br/> Singapore <br/> Postcode: 408564</p>
          <p>Email: claims@samis.com.sg</p>
          <p>24/7 Phone: +65 9897 8654 </p>
        </div>
      </div>

      <div className="footer-copy">
        &copy; 2025 Samudra Adjusting & Marine Insurance Solutions Pte Ltd.
        Document Version 1.0.
      </div>
    </footer>
  );
}

export default Footer;